module.exports = __webpack_public_path__ + "img/hover_icon_strengths_needs.15277a82.svg";